import Promise from 'bluebird';
import _ from 'lodash';

// This helper function takes a list of components, and fires and resolves all of their loadActions
// that pass the actionFilter test. This means we can declare required data per route handler,
// and wait for the data to be fetched before we render on the server, or simply fire the loadActions
// (without waiting for the resolve) on the client.
export default function resolveRoutesLoadActions(dispatch, components, path, routeParams, search, country, language, host, store, isBackNavigation) {
  // Fire all loadActions and wait until they resolve.
  // Each loadAction can specify an extra function that will return the
  // action arguments, given the current route params and route search. If none is given,
  // default to handing only the params to the actionCreator.

  return Promise.all(_(components)
    .filter(component => component && component.loadActions)
    .map(component => component.loadActions)
    .flatten()
    .map(loadAction => {
      const args = {path, country, language, routeParams, search, host, isBackNavigation, storeState: store.getState()};
      const action = loadAction.action(args);

      const result = action ? dispatch(action) : Promise.resolve();

      if (!result || !result.then || !loadAction.secondaryAction) return result;

      return result.then(dispatchResult => {
        const secondaryAction = loadAction.secondaryAction(args, dispatchResult);
        if (secondaryAction) {
          return dispatch(secondaryAction);
        }
      });
    })
    .value());
}



// WEBPACK FOOTER //
// ./src/util/resolveRoutesLoadActions.js